import { render, staticRenderFns } from "./LocaleA.vue?vue&type=template&id=5c1dbb92"
import script from "./LocaleA.vue?vue&type=script&lang=js"
export * from "./LocaleA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports